import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="password-strength"
export default class extends Controller {
  static targets = ["input", "progress", "strengthText"];

  async connect() {
    // Dynamically import zxcvbn from CDN only when needed (it's ~400KB)
    const { default: zxcvbn } = await import("https://esm.sh/zxcvbn@4.4.2");
    this.zxcvbn = zxcvbn;
    this.updateStrength();
  }

  updateStrength() {
    if (!this.zxcvbn) return;
    const password = this.inputTarget.value;
    const result = this.zxcvbn(password);

    const score = result.score;
    const scoreText = this.getStrengthText(score);
    const scoreClass = this.getStrengthClass(score);
    const progressClass = this.getStrengthProgressClass(score);

    if (this.progressTarget) {
      this.progressTarget.value = score;
      this.progressTarget.classList.remove("red", "orange", "green");
      this.progressTarget.classList.add(progressClass);
    }

    if (this.strengthTextTarget) {
      this.strengthTextTarget.textContent = scoreText;
      this.strengthTextTarget.className = `text-sm ${scoreClass}`;
    }
  }

  getStrengthText(score) {
    switch (score) {
      case 0:
        return "Very Weak";
      case 1:
        return "Weak";
      case 2:
        return "Medium";
      case 3:
        return "Strong";
      case 4:
        return "Very Strong";
      default:
        return "";
    }
  }

  getStrengthClass(score) {
    switch (score) {
      case 0:
        return "text-danger";
      case 1:
        return "text-danger";
      case 2:
        return "text-warning";
      case 3:
        return "text-success";
      case 4:
        return "text-success";
      default:
        return "";
    }
  }

  getStrengthProgressClass(score) {
    switch (score) {
      case 0:
        return "red";
      case 1:
        return "red";
      case 2:
        return "orange";
      case 3:
        return "green";
      case 4:
        return "green";
      default:
        return "";
    }
  }
}
